var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 30.9 22.1"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18023",
    transform: "translate(0.5 -0.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-volume-2",
    transform: "translate(1 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: "1px",
    fill: "currentcolor",
    id: "Trac\\xE9_6530",
    d: "M13.5-0.4c0.3,0,0.5,0.2,0.5,0.5v21c0,0.3-0.2,0.5-0.5,0.5c-0.1,0-0.2,0-0.3-0.1l-7.4-5.9H0 c-0.3,0-0.5-0.2-0.5-0.5v-9c0-0.3,0.2-0.5,0.5-0.5h5.8l7.4-5.9C13.3-0.4,13.4-0.4,13.5-0.4z M13,20.1V1.1L6.3,6.5 C6.2,6.6,6.1,6.6,6,6.6H0.5v8H6c0.1,0,0.2,0,0.3,0.1L13,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: "1px",
    fill: "currentcolor",
    id: "Trac\\xE9_6531",
    d: "M20.3,16.4c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0.1-0.3,0.1-0.4c2.7-2.7,2.7-7.2,0-9.9c-0.2-0.2-0.2-0.5,0-0.7 c0.2-0.2,0.5-0.2,0.7,0c0,0,0,0,0,0c3.1,3.1,3.1,8.2,0,11.3C20.6,16.3,20.4,16.4,20.3,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: "1px",
    fill: "currentcolor",
    id: "Trac\\xE9_6991",
    d: "M25.5,21.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0.1-0.3,0.1-0.4c5.6-5.6,5.6-14.7,0-20.4 c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0c6,6,6,15.8,0,21.8C25.8,21.6,25.7,21.6,25.5,21.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySound);
export default __webpack_public_path__ + "static/media/play-sound.d58ce6f66ac6223b4b43eef7e6c4bf2f.svg";
export { ForwardRef as ReactComponent };